import { createAction } from 'redux-act';
// add Assets action
const addAssetsRequest = createAction('ADD_ASSETS_REQUEST', data => data);
const addAssetsSuccess = createAction('ADD_ASSETS_SUCCESS', data => data);
const addAssetsError = createAction('ADD_ASSETS_ERROR');

// get All Assets List action
const getAllAssetsListRequest = createAction('GET_ALL_ASSETS_LIST_REQUEST', data => data);
const getAllAssetsListSuccess = createAction('GET_ALL_ASSETS_LIST_SUCCESS', data => data);
const getAllAssetsListError = createAction('GET_ALL_ASSETS_LIST_ERROR');

// get Assets bY Department action
const getAssetsRequest = createAction('GET_ASSETS_REQUEST', data => data);
const getAssetsSuccess = createAction('GET_ASSETS_SUCCESS', data => data);
const getAssetsError = createAction('GET_ASSETS_ERROR');

// Update Assets action
const updateAssetsRequest = createAction('UPDATE_ASSETS_REQUEST', data => data);
const updateAssetsSuccess = createAction('UPDATE_ASSETS_SUCCESS', data => data);
const updateAssetsError = createAction('UPDATE_ASSETS_ERROR');

// Delete Assets action
const deleteAssetsRequest = createAction('DELETE_ASSETS_REQUEST', data => data);
const deleteAssetsSuccess = createAction('DELETE_ASSETS_SUCCESS', data => data);
const deleteAssetsError = createAction('DELETE_ASSETS_ERROR');

// Assets In Stock action
const assetsInStockRequest = createAction('ASSETS_IN_STOCK_REQUEST', data => data);
const assetsInStockSuccess = createAction('ASSETS_IN_STOCK_SUCCESS', data => data);
const assetsInStockError = createAction('ASSETS_IN_STOCK_ERROR');

// Assign Asset To Employee action
const assignAssetToEmployeeRequest = createAction('ASSIGN_ASSETS_TO_EMPLOYEE_REQUEST', data => data);
const assignAssetToEmployeeSuccess = createAction('ASSIGN_ASSETS_TO_EMPLOYEE_SUCCESS', data => data);
const assignAssetToEmployeeError = createAction('ASSIGN_ASSETS_TO_EMPLOYEE_ERROR');

// Get Assign Asset action
const getAssignAssetRequest = createAction('GET_ASSIGN_ASSETS_REQUEST', data => data);
const getAssignAssetSuccess = createAction('GET_ASSIGN_ASSETS_SUCCESS', data => data);
const getAssignAssetError = createAction('GET_ASSIGN_ASSETS_ERROR');

// Release Assets action
const releaseAssetsRequest = createAction('RELEASE_ASSETS_REQUEST', data => data);
const releaseAssetsSuccess = createAction('RELEASE_ASSETS_SUCCESS', data => data);
const releaseAssetsError = createAction('RELEASE_ASSETS_ERROR');

// Asset Undertaking action
const assetUndertakingRequest = createAction('ASSET_UNDERTAKING_FORM_REQUEST', data => data);
const assetUndertakingSuccess = createAction('ASSET_UNDERTAKING_FORM_SUCCESS', data => data);
const assetUndertakingError = createAction('ASSET_UNDERTAKING_FORM_ERROR');

// Get Asset Undertaking action
const getAssetUndertakingRequest = createAction('GET_ASSET_UNDERTAKING_REQUEST', data => data);
const getAssetUndertakingSuccess = createAction('GET_ASSET_UNDERTAKING_SUCCESS', data => data);
const getAssetUndertakingError = createAction('GET_ASSET_UNDERTAKING_ERROR');

// Get Asset Request Data action
const assetRequestRequest = createAction('ASSET_REQUEST_REQUEST', data => data);
const assetRequestSuccess = createAction('ASSET_REQUEST_SUCCESS', data => data);
const assetRequestError = createAction('ASSET_REQUEST_ERROR');

// Get Asset Approval action
const getAssetApprovalRequest = createAction('GET_ASSET_REQUEST_REQUEST', data => data);
const getAssetApprovalSuccess = createAction('GET_ASSET_REQUEST_SUCCESS', data => data);
const getAssetApprovalError = createAction('GET_ASSET_REQUEST_ERROR');

// Get Asset Approval action
const approveAssetRequestRequest = createAction('APPROVE_ASSET_REQUEST_REQUEST', data => data);
const approveAssetRequestSuccess = createAction('APPROVE_ASSET_REQUEST_SUCCESS', data => data);
const approveAssetRequestError = createAction('APPROVE_ASSET_REQUEST_ERROR');

// Get Asset Request Data action
const getAssetRequestDataRequest = createAction('GET_ASSET_REQUEST_DATA_REQUEST', data => data);
const getAssetRequestDataSuccess = createAction('GET_ASSET_REQUEST_DATA_SUCCESS', data => data);
const getAssetRequestDataError = createAction('GET_ASSET_REQUEST_DATA_ERROR');

// Get Asset Request Data action
const assignedAssetRequest = createAction('ASSIGNED_ASSET_REQUEST', data => data);
const assignedAssetSuccess = createAction('ASSIGNED_ASSET_SUCCESS', data => data);
const assignedAssetError = createAction('ASSIGNED_ASSET_ERROR');

// Get Asset Request Data action
const myAssetRequest = createAction('MY_ASSET_REQUEST', data => data);
const myAssetSuccess = createAction('MY_ASSET_SUCCESS', data => data);
const myAssetError = createAction('MY_ASSET_ERROR');

// Get Under Taking action
const getUnderTakingRequest = createAction('GET_UNDER_TAKING_REQUEST', data => data);
const getUnderTakingSuccess = createAction('GET_UNDER_TAKING_SUCCESS', data => data);
const getUnderTakingError = createAction('GET_UNDER_TAKING_ERROR');

// Asset Summary action
const assetSummaryRequest = createAction('ASSET_SUMMARY_REQUEST', data => data);
const assetSummarySuccess = createAction('ASSET_SUMMARY_SUCCESS', data => data);
const assetSummaryError = createAction('ASSET_SUMMARY_ERROR');

// Asset Summary action
const cancelAssetRequestRequest = createAction('CANCEL_ASSET_REQUEST_REQUEST', data => data);
const cancelAssetRequestSuccess = createAction('CANCEL_ASSET_REQUEST_SUCCESS', data => data);
const cancelAssetRequestError = createAction('CANCEL_ASSET_REQUEST_ERROR');

// Team Asset action
const teamAssetRequest = createAction('TEAM_ASSET_REQUEST', data => data);
const teamAssetSuccess = createAction('TEAM_ASSET_SUCCESS', data => data);
const teamAssetError = createAction('TEAM_ASSET_ERROR');


// clear existing Assets action
const handleClearAssetsStore = createAction('HANDLE_CLEAR_ASSETS_STORE', data => data);
// const toastMsgAction = createAction('SUCCESS', data=> data);

export default {
    addAssetsRequest,
    addAssetsSuccess,
    addAssetsError,

    getAllAssetsListRequest,
    getAllAssetsListSuccess,
    getAllAssetsListError,

    getAssetsRequest,
    getAssetsSuccess,
    getAssetsError,

    updateAssetsRequest,
    updateAssetsSuccess,
    updateAssetsError,

    deleteAssetsRequest,
    deleteAssetsSuccess,
    deleteAssetsError,

    assetsInStockRequest,
    assetsInStockSuccess,
    assetsInStockError,

    assignAssetToEmployeeRequest,
    assignAssetToEmployeeSuccess,
    assignAssetToEmployeeError,

    getAssignAssetRequest,
    getAssignAssetSuccess,
    getAssignAssetError,

    releaseAssetsRequest,
    releaseAssetsSuccess,
    releaseAssetsError,

    assetUndertakingRequest,
    assetUndertakingSuccess,
    assetUndertakingError,

    getAssetUndertakingRequest,
    getAssetUndertakingSuccess,
    getAssetUndertakingError,

    assetRequestRequest,
    assetRequestSuccess,
    assetRequestError,

    getAssetApprovalRequest,
    getAssetApprovalSuccess,
    getAssetApprovalError,

    approveAssetRequestRequest,
    approveAssetRequestSuccess,
    approveAssetRequestError,

    getAssetRequestDataRequest,
    getAssetRequestDataSuccess,
    getAssetRequestDataError,

    assignedAssetRequest,
    assignedAssetSuccess,
    assignedAssetError,

    myAssetRequest,
    myAssetSuccess,
    myAssetError,

    getUnderTakingRequest,
    getUnderTakingSuccess,
    getUnderTakingError,


    assetSummaryRequest,
    assetSummarySuccess,
    assetSummaryError,

    cancelAssetRequestRequest,
    cancelAssetRequestSuccess,
    cancelAssetRequestError,

    teamAssetRequest,
    teamAssetSuccess,
    teamAssetError,

    handleClearAssetsStore,
    // toastMsgAction,

}